module.exports = {
  "AccessibilityTokens" : {
    "focusring": {
        "borderstyle": {
            "value": "dashed"
        },
        "borderwidth": {
            "value": "1px"
        },
        "space": {
            "offset": {
                "value": "2px"
            }
        }
    },
    "color": {
        "focusring": {
            "onlight": {
                "value": "#000000"
            },
            "ondark": {
                "value": "#ffffff"
            }
        }
    }
}
    }


//////////////////
// WEBPACK FOOTER
// ./~/@vds-tokens/accessibility/dist/cjs/tokens.js
// module id = 13
// module chunks = 0